import { StudentAppSectionCombinedProps } from './types';

const usePresenter = (props: StudentAppSectionCombinedProps): StudentAppSectionCombinedProps => {
  return props;
};

export default usePresenter;
